import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { templateData } from "./templateData";
import { getTemplateByName } from "./api/template.service";

const templates = templateData;
export default function TemplatesPage() {
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [selectedTemplate, setSelectedTemplate] = useState("");
    const navigate = useNavigate();

   const handlePreview = async (id) => {
  setLoading(true);

  const template = templateData.find((t) => t.id === id);

  try {
    // 🔥 TRY DB FIRST
    const data = await getTemplateByName(template.name, 1);

    if (data) {
      // ✅ DB DATA
      setSelectedTemplate(data);
    } else {
      // ✅ FALLBACK
      setSelectedTemplate(template);
    }
  } catch (err) {
    // ❌ ERROR → fallback
    setSelectedTemplate(template);
  }

  setLoading(false);
  setShowModal(true);
};
    return (
        <div style={styles.container}>
            <div style={styles.content}>
                <h2 style={styles.heading}>Templates</h2>

                <div style={styles.table}>
                    <div style={styles.tableHeader}>
                        <div>Email Templates</div>
                        <div>Actions</div>
                    </div>

                    {templates.map((item) => (
                        <div key={item.id} style={styles.row}>
                            <div>{item.name}</div>

                            <div>
                                <span
                                    style={styles.icon}
                                    onClick={() => handlePreview(item.id)}
                                >
                                    👁
                                </span>

                                <span
                                    style={styles.icon}
                                    onClick={() => navigate(`/templates/edit/${item.id}`)}
                                >
                                    ✏️
                                </span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* 🔄 Loader */}
            {loading && (
                <div style={styles.loaderOverlay}>
                    <div style={styles.loader}>Loading...</div>
                </div>
            )}

            {/* 📩 Modal Preview */}
            {showModal && (
                <div style={styles.modalOverlay}>
                    <div style={styles.modal}>
                        <div style={styles.modalHeader}>
                            <h3>Email Template Preview</h3>
                            <span
                                style={{ cursor: "pointer" }}
                                onClick={() => setShowModal(false)}
                            >
                                ❌
                            </span>
                        </div>

                        <div
                            style={styles.previewBox}
                            dangerouslySetInnerHTML={{
                                __html: selectedTemplate?.content,
                            }}
                        />
                        <button
                            style={styles.closeBtn}
                            onClick={() => setShowModal(false)}
                        >
                            Close
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}

const styles = {
    container: {
        display: "flex",
        height: "100vh",
        fontFamily: "Arial",
    },

    content: {
        width: "100%",
        padding: "20px",
        background: "#f5f6fa",
    },

    heading: {
        marginBottom: "20px",
    },

    table: {
        background: "#fff",
        borderRadius: "6px",
        border: "1px solid #ddd",
    },

    tableHeader: {
        display: "flex",
        justifyContent: "space-between",
        padding: "12px 16px",
        background: "#ecf0f1",
        fontWeight: "bold",
    },

    row: {
        display: "flex",
        justifyContent: "space-between",
        padding: "12px 16px",
        borderTop: "1px solid #eee",
    },

    icon: {
        marginLeft: "10px",
        cursor: "pointer",
    },

    /* Loader */
    loaderOverlay: {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "rgba(0,0,0,0.3)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 999,
    },

    loader: {
        background: "#fff",
        padding: "20px",
        borderRadius: "6px",
    },

    /* Modal */
    modalOverlay: {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "rgba(0,0,0,0.4)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000,
    },

    modal: {
        width: "600px",
        background: "#fff",
        borderRadius: "8px",
        padding: "20px",
    },

    modalHeader: {
        display: "flex",
        justifyContent: "space-between",
        marginBottom: "10px",
    },

    previewBox: {
        background: "#f1f1f1",
        padding: "20px",
        borderRadius: "6px",
    },

    footer: {
        marginTop: "20px",
        fontSize: "12px",
        color: "gray",
    },

    closeBtn: {
        marginTop: "15px",
        padding: "8px 12px",
        background: "#3498db",
        color: "#fff",
        border: "none",
        cursor: "pointer",
    },
};